import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { ThemeProvider, createTheme } from "@mui/material/styles";

import HomeScreen from "./components/HomeScreen";

const THEME = createTheme({
  typography: {
    fontFamily: "Circular,sans-serif",
    fontWeight: "600"
  },
});

function App() {
  return (
    <div>
      <ThemeProvider theme={THEME}>
        <HomeScreen />
      </ThemeProvider>
    </div>
  );
}

export default App;
